import React from "react";
import Text from "../../../components/Common/Text";
import { DisclaimerContainer } from "../styles/DashboardStyles";
import useEmpresa from "../../../hooks/useEmpresa";

const DashboardDisclaimer = ({ title, text }) => {
  const empresa = useEmpresa();

  return (
    <DisclaimerContainer colorBorder={empresa?.COLOR_SECUNDARIO}>
      <Text size="17px" color={empresa?.COLOR_PRINCIPAL} weight={"bold"}>
        {title}
      </Text>

      <Text size="16px" color={empresa?.COLOR_PRINCIPAL}>
        {text}
      </Text>
    </DisclaimerContainer>
  );
};

export default DashboardDisclaimer;